import { styled } from "@mui/material"

export const Wrapp = styled("div")(() => ({
  width: 400,
  textAlign: "center",
}))

export const Title = styled("div")(() => ({
  fontWeight: 600,
  lineHeight: "20px",
}))

export const ButtonsBlock = styled("div")(() => ({
  marginTop: 40,
  display: "flex",
  gap: 12,
  justifyContent: "center",
}))
